<template>
  <div class="tab-holder">
    <button 
      class="tab-btn"
      :class="{ 'active-tab': currentTab === tab }"
      v-for="(tab) in tabs"
      :key="`btn_${tab}`"
      type="button" 
      @click="onSwitchTab(tab)"
    >
      choose a {{ tab === 'subGroup' ? 'subgroup' : camelToTitle(tab) }}
    </button>
  </div>
</template>

<script>
import { computed, onBeforeMount } from '@vue/composition-api';
import { camelToTitle } from '@utils';
import { useStore } from '@vue3shims';

export default {
  setup(_, { emit }) {
    const store = useStore();

    const currentTab = computed(() => store.getters['groupSelector/currentTab']);
    const tabs = computed(() => {
      let tabs = store.getters['groupSelector/tabs'] || [];
      let userHasOneParent = store.getters['groupSelector/userHasOneParent'];
      if(userHasOneParent) {
        return tabs.filter(tab => tab !== 'parentGroup');
      }
      return tabs;
    });
    const onSwitchTab = (tab) => emit('activate-tab', tab);

    return {
      camelToTitle,
      currentTab,
      onSwitchTab,
      tabs,
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-holder {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .tab-btn {
    background-color: $white;
    color: $color-search-text;
    font-size: 0.85rem;
    width: 100%;
    border: 1px solid #d8d8d8;;

    &.active-tab {
      background-color: $color-light-gray-alt;
      color: $leaf;
      box-shadow: none !important;
    }
  }
}
</style>
